import { all } from "redux-saga/effects";

export default function* workPerformanceSaga() {
  yield all([]);
}
